import { Alert } from '@customink/pigment-react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { WCIBMO_NAMES } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { hasValidZipCodeAtom } from '@/hooks/useValidateZipCode';
import { pageViewTag } from '@/utils/metrics';

export default function QuantityNeededForPrice() {
  const [isDismissed, setIsDismissed] = useState(false);
  const quantityType = useOrderQuantityType();
  const hasValidZipCode = useAtomValue(hasValidZipCodeAtom);

  if (hasValidZipCode) {
    pageViewTag(
      `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.ENTER_QUANTITIES}`,
    );
  }

  if (isDismissed) {
    return null;
  }

  return (
    <Alert onClose={() => setIsDismissed(true)} severity="warning">
      Some items are missing quantities.
    </Alert>
  );
}
